document.addEventListener("DOMContentLoaded", () => {
  // Color swatches functionality using event delegation
  const allCards = document.querySelectorAll(".card-product");

  allCards.forEach((product) => {
    const slider = product.querySelector(".card__slider-container");
    if (slider) {
      initializeSlider(slider);
    }

    handleRestNumber(product);

    product.addEventListener("click", (e) => {
      // Handle color swatches
      const colorOption = e.target.closest(
        ".card-product__color-option:not(.disabled)"
      );

      // Color Swatches Function
      if (colorOption) {
        e.preventDefault();
        handleColorSwatch(colorOption, product);
      }

      // Handle slider navigation
      const nextBtn = e.target.closest(".card__slider-arrow.next");
      const prevBtn = e.target.closest(".card__slider-arrow.prev");

      if (nextBtn || prevBtn) {
        e.preventDefault();
        if (nextBtn) {
          slideToNext(slider);
        } else {
          slideToPrev(slider);
        }
      }
    });
  });

  // Initialize slider with clones
  function initializeSlider(slider) {
    const slides = slider.querySelectorAll(".card__slider-image");
    const slidesLength = slides.length;

    if (slidesLength <= 1) return; // No need for slider if only one image

    // Create clones for infinite effect
    const cloneFirst = slides[0].cloneNode(true);
    const cloneLast = slides[slidesLength - 1].cloneNode(true);

    slider.appendChild(cloneFirst);
    slider.insertBefore(cloneLast, slider.firstChild);

    slider.dataset.activeIndex = "1";
    slider.dataset.max = slidesLength;
    slider.dataset.isAnimating = "false";
    slider.style.transform = "translateX(-100%)";
  }

  // Handle color swatch selection
  function handleColorSwatch(colorOption, productCard) {
    // Check if already active
    if (colorOption.getAttribute("aria-current") === "true") return;

    const featuredImage = productCard.querySelector(
      ".card-product__image-container .card-product__image"
    );

    // Update active state
    colorOption
      .closest(".card-product__colors")
      .querySelectorAll(".card-product__color-option")
      .forEach((btn) => btn.setAttribute("aria-current", "false"));
    colorOption.setAttribute("aria-current", "true");

    // Update images
    const newImageSrc = colorOption.dataset.imageSrc;
    const newAltText = colorOption.dataset.imageAlt;

    if (featuredImage && newImageSrc) {
      featuredImage.src = newImageSrc;
      featuredImage.alt = newAltText;
    }
  }

  function handleRestNumber(product) {
    // COUNTER OF REST SWATCHES
    const colorsHolder = product.querySelector(".card-product__colors");
    const colorOptions = product.querySelectorAll(
      ".card-product__color-option"
    );
    if (colorsHolder && colorOptions.length > 4) {
      const restCounter = colorsHolder.querySelector(".rest-counter");
      const restNumber = colorOptions.length - 4;
      restCounter.style.display = "inline";
      restCounter.textContent = `+${restNumber}`;
    }
  }

  // Slide to next image
  function slideToNext(slider) {
    if (slider.dataset.isAnimating === "true") return;

    let currentIndex = parseInt(slider.dataset.activeIndex);
    const slidesLength = parseInt(slider.dataset.max);

    slider.dataset.isAnimating = "true";
    currentIndex++;
    slider.dataset.activeIndex = currentIndex;
    updateSliderPosition(slider, currentIndex);

    // If we reached the clone at the end, reset to first slide
    if (currentIndex === slidesLength + 1) {
      setTimeout(() => {
        slider.style.transition = "none";
        currentIndex = 1;
        slider.dataset.activeIndex = currentIndex;
        updateSliderPosition(slider, currentIndex);
        setTimeout(() => {
          slider.style.transition = "transform 0.3s ease-out";
          slider.dataset.isAnimating = "false";
        }, 20);
      }, 300);
    } else {
      setTimeout(() => {
        slider.dataset.isAnimating = "false";
      }, 300);
    }
  }

  // Slide to previous image
  function slideToPrev(slider) {
    if (slider.dataset.isAnimating === "true") return;

    let currentIndex = parseInt(slider.dataset.activeIndex);
    const slidesLength = parseInt(slider.dataset.max);

    slider.dataset.isAnimating = "true";
    currentIndex--;
    slider.dataset.activeIndex = currentIndex;
    updateSliderPosition(slider, currentIndex);

    // If we reached the clone at the start, reset to last slide
    if (currentIndex === 0) {
      setTimeout(() => {
        slider.style.transition = "none";
        currentIndex = slidesLength;
        slider.dataset.activeIndex = currentIndex;
        updateSliderPosition(slider, currentIndex);
        setTimeout(() => {
          slider.style.transition = "transform 0.3s ease-out";
          slider.dataset.isAnimating = "false";
        }, 20);
      }, 300);
    } else {
      setTimeout(() => {
        slider.dataset.isAnimating = "false";
      }, 300);
    }
  }

  // Update slider position
  function updateSliderPosition(slider, index) {
    slider.style.transform = `translateX(calc(-${index} * 100%))`;
  }

  window.handleColorSwatch = handleColorSwatch;
});
